var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"image-wrapper",attrs:{"elevation":"0","max-height":"630","max-width":"540"}},[_c('v-img',{attrs:{"src":"https://vet2pet-prod-main-store.s3.eu-west-1.amazonaws.com/assets/fortiflora_large.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }